/*
 * @Author: ylq
 * @Date: 2022-09-26 15:14:37
 * @Desc: Main
 * @Last Modified by: ylq
 * @Last Modified time: 2025-07-24 16:48:38
 */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import components from './components';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon'; // 额外引入图标库
// import '@arco-design/web-vue/dist/arco.css';
import '@arco-themes/vue-martix/index.less';
import './assets/style/main.less';
import './assets/style/div-input.less';
import directive from './directive';
import vue3TreeOrg from 'vue3-tree-org';
import 'vue3-tree-org/lib/vue3-tree-org.css';
import Vue3Lottie from 'vue3-lottie';
import TDesign from 'tdesign-vue-next';
import skyWalking from './utils/sky-walking';
import initSentry from './hooks/sentry';
import qfeiIconImport from './hooks/qfei-icon';

// 引入组件库的少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';
/********************* 注册echarts主题 start *********************/

import * as echarts from 'echarts';
import { vintage, dark, westeros, essos, wonderland, walden, chalk, infographic, macarons, roma, shine, purplePassion } from './assets/theme/echarts-theme';
echarts.registerTheme('vintage', vintage);
echarts.registerTheme('dark', dark);
echarts.registerTheme('westeros', westeros);
echarts.registerTheme('essos', essos);
echarts.registerTheme('wonderland', wonderland);
echarts.registerTheme('walden', walden);
echarts.registerTheme('chalk', chalk);
echarts.registerTheme('infographic', infographic);
echarts.registerTheme('macarons', macarons);
echarts.registerTheme('roma', roma);
echarts.registerTheme('shine', shine);
echarts.registerTheme('purplePassion', purplePassion);
/********************* 注册echarts主题 end *********************/

import i18n from './locales';
const app = createApp(App);
initSentry(app, router);
qfeiIconImport(app);
app.use(router);
app.use(store);
app.use(components);
app.use(ArcoVue, { componentPrefix: 'jw' });
app.use(ArcoVueIcon);
app.use(directive);
app.use(vue3TreeOrg);
app.use(Vue3Lottie);
app.use(i18n);
app.use(TDesign);
skyWalking(app);
app.mount('#app');
